module.exports = __webpack_public_path__ + "img/snowfall.ca27ab40.png";